var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TagBody",style:(_vm.width ? `width: ${_vm.width}px` : 'width: 170px')},[_c('div',{staticClass:"text-center d-flex align-center pa-2",style:(`background: ${_vm.color}`)},[(_vm.changeImageUrl)?_c('v-img',{attrs:{"src":require(
        `@/assets/icons/vehiclePage/${_vm.icon}.svg`
      )}}):_c('v-img',{attrs:{"src":require(
        `@/assets/icons/stageSelectIcons/${_vm.icon}.svg`
      )}})],1),_c('div',{staticClass:"tagSubBody"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }